import { useState } from "react";
import { num } from "@/lib/format";
import { STATUS } from "@/components/MaterialsCoverage";
import { Badge } from "@/components/ui/badge";
import { BellRing, ChevronDown, Heart } from "lucide-react";

const SizeRow = ({ z }) => {
  const missing = (z.restock || z.wishlist) && !z.stock;
  return (
    <div className={`grid grid-cols-4 gap-2 rounded px-2 py-1 text-xs ${missing ? "bg-rose-500/10 text-rose-300" : ""}`} data-testid="demand-size-row">
      <span className="font-medium">{z.size}</span>
      <span>{num(z.restock)} avvisami</span>
      <span>{num(z.wishlist)} wishlist</span>
      <span>{z.stock == null ? "—" : `${num(z.stock)} in magazzino`}</span>
    </div>
  );
};

export const DemandRow = ({ r }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-border/40 last:border-0" data-testid={`demand-row-${r.sku}`}>
      <button onClick={() => setOpen(!open)} className="grid w-full grid-cols-2 items-center gap-2 py-2.5 text-left text-sm md:grid-cols-[2fr_100px_100px_100px_100px_170px_20px]" data-testid={`demand-toggle-${r.sku}`}>
        <div className="col-span-2 flex min-w-0 items-center gap-3 md:col-span-1">
          {r.image_url && <img src={r.image_url} alt="" className="h-10 w-10 shrink-0 rounded object-cover" />}
          <div className="min-w-0">
            <p className="truncate font-medium">{r.name}</p>
            <p className="text-xs text-muted-foreground">{r.color || "—"} · {r.season || "—"}</p>
          </div>
        </div>
        <span className="flex items-center gap-1 md:justify-end" data-testid={`demand-restock-${r.sku}`}><BellRing className="h-3.5 w-3.5 text-amber-400" />{num(r.restock)}</span>
        <span className="flex items-center gap-1 md:justify-end" data-testid={`demand-wishlist-${r.sku}`}><Heart className="h-3.5 w-3.5 text-rose-400" />{num(r.wishlist)}</span>
        <span className="text-xs md:text-right md:text-sm"><span className="text-muted-foreground md:hidden">Magazzino </span>{num(r.stock)}</span>
        <span className="text-xs font-semibold md:text-right md:text-sm"><span className="font-normal text-muted-foreground md:hidden">Producibili </span>{r.producible == null ? "—" : num(r.producible)}</span>
        <Badge variant="outline" className={`justify-center text-[10px] ${STATUS[r.status][1]}`}>{STATUS[r.status][0]}</Badge>
        <ChevronDown className={`hidden h-4 w-4 text-muted-foreground transition-transform md:block ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mb-3 space-y-1 rounded-md bg-secondary/30 p-2" data-testid={`demand-sizes-${r.sku}`}>
          {r.sizes.map((z) => <SizeRow key={z.size} z={z} />)}
          {r.limiting && <p className="px-2 pt-1 text-[11px] text-muted-foreground">Materiale limitante: {r.limiting.name} ({num(r.limiting.available)} {r.limiting.unit || ""})</p>}
        </div>
      )}
    </div>
  );
};
